<div class="bg-gray2 pb-2 pt-1 py-md-3" data-e2e="other-contracts">
  <div class="site-width">
    <div class="container-fluid">
      <h2 data-e2e="other-contracts-title">{{"dashboard.contractsAndOptions.manageContract.title" | translate}}</h2>
      <div class="row pt-1">
        <div class="col-12 col-md-6 col-lg-5 pr-3">
          <h3 class="lead font-weight-bold mb-1 mb-md-2" data-e2e="other-contracts-subtitle">
            {{"dashboard.contractsAndOptions.manageContract.subTitle" | translate}}
          </h3>
          <div data-e2e="other-contracts-comments">
            {{"dashboard.contractsAndOptions.manageContract.text" | translate}}
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-7 mt-2 mt-md-0">
          <div class="d-flex justify-content-center justify-content-md-start">
            <div class="d-flex flex-column">
              <a
                class="btn btn-primary mb-2"
                [href]="addContractLink | link | async"
                data-e2e="add-contract"
                (click)="addContract();false"
              >
                {{ addContractData.button }}
              </a>
              @if (canDisplayRemoveContractButton) {
              <a
                class="btn btn-secondary"
                data-e2e="remove-contract"
                [href]="removeContractLink | link | async"
                (click)="removeContract();false"
              >
                {{"dashboard.contractsAndOptions.manageContract.removeContract.button" | translate}}
              </a>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
